/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ViaType model module.
 * @module model/ViaType
 * @version 1.0.0
 */
class ViaType {
    /**
     * Constructs a new <code>ViaType</code>.
     * @alias module:model/ViaType
     */
    constructor() { 
        
        ViaType.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ViaType</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ViaType} obj Optional instance to populate.
     * @return {module:model/ViaType} The populated <code>ViaType</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ViaType();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('main')) {
                obj['main'] = ApiClient.convertToType(data['main'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
ViaType.prototype['id'] = undefined;

/**
 * @member {String} name
 */
ViaType.prototype['name'] = undefined;

/**
 * @member {Boolean} main
 */
ViaType.prototype['main'] = undefined;






export default ViaType;

